import { IPart } from "../models/Part";

// Resolves the eBay item number for the part's *active* offer, but only when that
// offer is actually live on eBay right now (published, not ended, has a listing id).
// Use this instead of the denormalised part.ebayItemNumber when linking out to eBay —
// that field is only refreshed by the async eBay sync jobs, so right after a
// withdraw/relist it can still point at the old, now-ended listing.
export default function getLiveEbayItemNumber(part: IPart): string | null {
  if (!part.offers || part.offers.length === 0) return null;

  const activeOffer = part.offers.find((o) => o.id === part.activePartOfferId) ?? part.offers[0];
  if (!activeOffer) return null;

  const isLive = Boolean(activeOffer.publishedOn) && !activeOffer.listingEnded && Boolean(activeOffer.ebayId);

  return isLive ? activeOffer.ebayId : null;
}
